import {
    FlexiEditButton,
    PlatformPropertyCard,
    PlatformPropertyCardProperty
} from '@flexinet/ui-components';
import {useUserProfileAttributes} from '../hooks/useUserProfileAttributes';
import {
    Card,
    Group,
    ThemeIcon,
    Title
} from '@mantine/core';
import {AiOutlinePhone} from 'react-icons/ai';
import {useNavigate} from 'react-router-dom';
import {emptyState} from './emptyState';

export const ContactProfile = () => {

    const navigate = useNavigate();

    const {
        address,
        website,
        phoneNumber,
        locale,
        zoneInfo,
    } = useUserProfileAttributes();

    const properties: PlatformPropertyCardProperty[] = [
        {
            label: 'Phone Number',
            value: phoneNumber || emptyState('Add phone number'),
            span: 6,
        },
        {
            label: 'Address',
            value: address || emptyState('Add address'),
            span: 6,
        },
        {
            label: 'Website',
            value: website || emptyState('Add website'),
            span: 12,
        },
        {
            label: 'Locale',
            value: locale || emptyState('Set locale'),
            span: 6,
        },
        {
            label: 'Time Zone',
            value: zoneInfo || emptyState('Set time zone'),
            span: 6,
        },
    ];

    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Group justify="space-between" mb="md">
                <Group gap="xs">
                    <ThemeIcon variant="outline" size="lg" color="blue">
                        <AiOutlinePhone size={20}/>
                    </ThemeIcon>
                    <Title order={5}>Contact & Location</Title>
                </Group>
                <FlexiEditButton
                    onClick={() => navigate('/user-profile/update/#contact')}
                    aria-label="Edit contact and location details"
                />
            </Group>
            <PlatformPropertyCard properties={properties}/>
        </Card>
    );
};
